import { render, staticRenderFns } from "./AddOrderDetailComponent.vue?vue&type=template&id=d8cdf15c&"
import script from "./AddOrderDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AddOrderDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports